import * as momentRoutines from './momentRoutines';
import * as momentSelectors from './selectors';
import * as userRoutines from '../../sagas/routines/userRoutines';
import { connect } from 'react-redux';
import Moments from '../../Components/Moments/Moments';

const mapState2Props = (state: any) => {
    return {
        config: momentSelectors.makeOrderedConfig(state),
        posts: momentSelectors.makeMomentsWithComments(state),
    };
};

const mapDispatchToProps = {
    createMoment: momentRoutines.createMoment,
    createMomentFilter: momentRoutines.createMomentFilter,
    deleteMomentFilter: momentRoutines.deleteMomentFilter,
    fetchUserAvatar: userRoutines.fetchUserAvatar,
    removeMoment: momentRoutines.removeMoment,
    toggleMomentConfigSetting: momentRoutines.toggleMomentConfigSetting,
    updateMomentFilter: momentRoutines.updateMomentFilter,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(Moments);
